import React, { useEffect, useState } from "react";
import { api, formatMoney } from "@/lib/api";

const FILTERS = [
  { v: "all", label: "All" },
  { v: "p2p_transfer", label: "Transfers" },
  { v: "payment_link", label: "Payment links" },
  { v: "wallet_topup", label: "Top-ups" },
];

export default function Transactions() {
  const [items, setItems] = useState([]);
  const [filter, setFilter] = useState("all");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/transactions");
        setItems(data);
      } catch {}
      setLoading(false);
    })();
  }, []);

  const visible = items.filter((t) => filter === "all" || t.type === filter);

  return (
    <main data-testid="transactions-page" className="max-w-7xl mx-auto px-6 lg:px-10 py-12">
      <div className="text-xs uppercase tracking-[0.3em] text-gold">Ledger</div>
      <h1 className="font-display text-5xl tracking-tighter mt-3">Transactions</h1>

      <div className="mt-10 flex flex-wrap gap-2">
        {FILTERS.map((f) => (
          <button
            key={f.v}
            data-testid={`filter-${f.v}`}
            onClick={() => setFilter(f.v)}
            className={`px-4 py-2 text-xs uppercase tracking-widest transition-all ${
              filter === f.v ? "text-gold border-b border-gold" : "text-secondary-fg hover:text-white border-b border-transparent"
            }`}
          >
            {f.label}
          </button>
        ))}
      </div>

      {loading ? (
        <div className="text-secondary-fg mt-10">Loading…</div>
      ) : visible.length === 0 ? (
        <div className="border hairline p-16 text-center mt-10">
          <div className="font-display text-2xl text-secondary-fg">No transactions</div>
        </div>
      ) : (
        <div className="border hairline mt-10">
          <div className="grid grid-cols-12 px-6 py-3 border-b hairline text-[10px] uppercase tracking-[0.25em] text-muted-fg">
            <div className="col-span-6">Description</div>
            <div className="col-span-3">Type</div>
            <div className="col-span-3 text-right">Amount</div>
          </div>
          {visible.map((t) => (
            <div key={t.tx_id} data-testid={`tx-${t.tx_id}`} className="grid grid-cols-12 gap-4 px-6 py-5 border-b hairline last:border-b-0 hover:bg-surface transition-colors">
              <div className="col-span-6">
                <div className="text-sm">{t.description || t.type}</div>
                <div className="text-xs text-muted-fg mt-1">{new Date(t.created_at).toLocaleString()}</div>
                {t.recipient_email && t.type === "p2p_transfer" && (
                  <div className="text-xs text-muted-fg mt-1">
                    {t.direction === "out" ? `→ ${t.recipient_email}` : `← ${t.sender_email}`}
                  </div>
                )}
              </div>
              <div className="col-span-3 text-xs uppercase tracking-widest text-muted-fg self-center">{t.type?.replace(/_/g, " ")}</div>
              <div className={`col-span-3 text-right font-display text-2xl ${t.direction === "in" ? "text-gold" : "text-secondary-fg"}`}>
                {t.direction === "in" ? "+" : "−"} {formatMoney(t.amount, t.currency)}
              </div>
            </div>
          ))}
        </div>
      )}
    </main>
  );
}
